import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../hooks/redux';
import { loginStep1, loginStep2, setLoginStep } from '../store/slices/authSlice';

const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { loginStep, authMethods, isLoading, error } = useAppSelector((state) => state.auth);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleStep1 = async (e: React.FormEvent) => {
    e.preventDefault();
    await dispatch(loginStep1(email));
  };

  const handleStep2 = async (e: React.FormEvent) => {
    e.preventDefault();
    const result = await dispatch(loginStep2({ email, password, method: 'password' }));
    if (loginStep2.fulfilled.match(result)) {
      navigate('/dashboard');
    }
  };

  return (
    <div className="mx-auto px-4 py-12 w-full max-w-[250px] lg:max-w-xl">
      <h1 className="text-3xl font-bold mb-6 text-center">Login</h1>
      {loginStep === 1 ? (
        <form onSubmit={handleStep1} className="space-y-4">
          <div>
            <label className="block mb-2 text-[var(--color-default-font)]">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 border border-[var(--color-neutral-border)] rounded bg-[var(--color-default-background)] text-[var(--color-default-font)] focus:outline-none focus:ring-2 focus:ring-[var(--color-brand-500)]"
              required
            />
          </div>
          <button
            type="submit"
            disabled={isLoading}
            className="w-full px-4 py-2 bg-[var(--color-brand-primary)] text-white rounded hover:bg-[var(--color-brand-700)]"
          >
            Continue
          </button>
        </form>
      ) : (
        <form onSubmit={handleStep2} className="space-y-4">
          <div>
            <label className="block mb-2 text-[var(--color-default-font)]">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 border border-[var(--color-neutral-border)] rounded bg-[var(--color-default-background)] text-[var(--color-default-font)] focus:outline-none focus:ring-2 focus:ring-[var(--color-brand-500)]"
              required
            />
          </div>
          <button
            type="submit"
            disabled={isLoading}
            className="w-full px-4 py-2 bg-[var(--color-brand-primary)] text-white rounded hover:bg-[var(--color-brand-700)]"
          >
            Login
          </button>
          <button
            type="button"
            onClick={() => dispatch(setLoginStep(1))}
            className="w-full text-[var(--color-brand-primary)]"
          >
            Back
          </button>
        </form>
      )}
      {error && <p className="text-[var(--color-error-600)] mt-4">{error}</p>}
    </div>
  );
};

export default LoginPage;

